import { utils } from 'ethers'

const getCreate2 = (deployer: string, salt: number, codeHash: string) => {
  const address = utils.getCreate2Address(deployer, utils.zeroPad(utils.hexlify(salt), 32), codeHash)
  return address
}

export default getCreate2
